import { normalizeSessionModelThinkingVariant } from "./reasoning";
import type { ModelRef, StoredSessionIntent } from "./types";

function normalizeModelRef(value: unknown): ModelRef | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }

  const candidate = value as Record<string, unknown>;
  const providerID =
    typeof candidate.providerID === "string" ? candidate.providerID.trim() : "";
  const modelID =
    typeof candidate.modelID === "string" ? candidate.modelID.trim() : "";

  if (!providerID || !modelID) {
    return null;
  }

  return {
    providerID,
    modelID,
  };
}

export function normalizeStoredSessionIntent(
  value: unknown,
): StoredSessionIntent | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }

  const candidate = value as Record<string, unknown>;

  if (candidate.kind === "use_defaults") {
    return { kind: "use_defaults" };
  }

  if (candidate.kind !== "explicit") {
    return null;
  }

  const model = normalizeModelRef(candidate.model);
  if (!model) {
    return null;
  }

  return {
    kind: "explicit",
    model,
    variant: normalizeSessionModelThinkingVariant(
      typeof candidate.variant === "string" ? candidate.variant : null,
    ),
  };
}
